import Vue from 'vue'
import Router from 'vue-router'
import HomePage from './components/_HomePage.vue'
import { displayType } from 'shared/util'
import { config } from './config'

Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '/',
			name: 'home',
			component: HomePage,
			meta: {
				title: 'ErgRace'
			}
		},
		{
			path: '/race',
			name: 'race',
			component: () => import('./_race/_normal/_RacePage.vue'),
			meta: {
				title: 'Race'
			}
		},
		{
			path: '/scroll',
			name: 'scroll',
			component: () => import('./_race/_normal/_RacePage.vue'),
			props: { userRequestedScrollMode: true },
			meta: {
				title: 'Race'
			}
		},
		{
			path: '/spectator/:logbook_id?',
			name: 'spectator',
			component: () => import('./_race/_app/_SpectatorPage.vue'),
			props: route => ({ userRequestedScrollMode: true }),
			meta: {
				title: 'Spectator'
			}
		},
		{
			path: '/leaderboard',
			name: 'leaderboard',
			component: () => import('./_leaderboard/_LdbdPage.vue'),
			meta: {
				title: 'Leaderboard'
			}
		},
		{
			path: '/summary',
			name: 'summary',
			component: () => import('./_leaderboard/_LdbdPage.vue'),
			props: { summaryMode: true },
			meta: {
				title: 'Summary'
			}
		},
		{
			path: '/participant/:logbook_id',
			component: () => import('./_race/_app/_ParticipantPage.vue'),
			name: 'participant',
			props: {
			  ParticipantPage: route => ({logbook_id: route.query.logbook_id})
			},
			meta: {
				title: 'Participant'
			}
		},
		{
			path: '/cameras1',
			component: () => import('./_camera/Cameras1.vue'),
			name: 'cameras1',
			meta: {
				title: 'One Camera'
			}
		},
		{
			path: '/cameras2',
			component: () => import('./_camera/Cameras2.vue'),
			name: 'cameras2',
			meta: {
				title: 'Two Cameras'
			}
		},
		{
			path: '/cameras3',
			component: () => import('./_camera/Cameras3.vue'),
			name: 'cameras3',
			meta: {
				title: 'Three Cameras'
			}
		},
				{
			path: '/split',
			component: () => import('./_camera/CamerasSplit.vue'),
			name: 'split',
			meta: {
				title: 'Split View'
			}
		},
		{
			path: '/workout',
			component: () => import('./_workout/WorkoutTable.vue'),
			name: 'workout',
			meta: {
				title: 'Workout'
			}
		}
	],
})

// When a new build is deployed, old JS in the browser will fail to load
// chunks whose hash no longer exists on the server. Force a full reload
// so the browser picks up the new build rather than showing a broken state.
router.onError((error) => {
	if (/Loading (CSS )?chunk \S+ failed|Failed to fetch/i.test(error.message)) {
		window.location.reload()
	}
})

router.afterEach((to, from) => {
	// config.set({ global: { route: to.name }})
	if(config.vals.global.remoteId) {
		config.setRemoteId(config.vals.global.remoteId, displayType(to.name || undefined))
	}
	document.title = to.meta?.title || ''
	const font = config.vals.globalTheme
	if(to?.name?.includes('cameras')) {
		config.set({ globalTheme: { font: 'Roboto, sans-serif' }})
	} else {
		config.set({ globalTheme: { font: 'Open Sans, sans-serif' }})
	}
})

export default router
